Controller.$inject = [];

function Controller() {
}

export function HuiPopoverContent() {
    return {
        restrict: 'E',
        scope: {},
        controller: Controller,
        controllerAs: '$huiPopoverContent',
        transclude: true,
        template: `
            <div class="hui-popover-content">
                <ng-transclude></ng-transclude>
            </div>
        `
    };
} 